<template>
  <section id="contact" class="page">
    <navigation class="absolute"></navigation>
    <div class="shapes">
      <div class="diamond" v-for="x in 7"></div>
      <div class="circle" v-for="x in 7"></div>
    </div>
    <div class="wrapper">
    <div class="box" v-for="item in items">
      <a v-if="item.link" :href="item.link" target="_blank">
        <img :src=" '/dist/' + item.icon" />
        <h3>{{item.title}}</h3>
        <a v-if="item.phone"  :href="'tel:' + item.phone">{{item.phone}}</a>
        <h3 v-else>{{item.subtitle}}</h3>
      </a>
      <template v-else>
        <img :src=" '/dist/' + item.icon" />
        <h3>{{item.title}}</h3>
        <a v-if="item.phone"  :href="'tel:' + item.phone">{{item.phone}}</a>
        <h3 v-else>{{item.subtitle}}</h3>
      </template>
    </div>
    </div>
  </section>
</template>

<script>
  import Navigation from '../components/navigation.vue';
  require.context('../../assets/contact/', true);


  export default {
    components: {Navigation},
    props: {
      id: String,
      name: String,
    },

    data () {
      return {
        items: [
          {
            title: 'Nikoleta Tasic',
            subtitle: 'Graphic & Web Designer',
            icon: 'contact_me_icon_graphic_designer.png'
          },{
            title: 'puuuter1@gmail.com',
            phone: '+1 312 953 4196',
            icon: 'contact_me_wave_email_icon.png'
          },{
            title: 'Chicago, USA',
            subtitle: 'Belgrade, Serbia',
            icon: 'contact_me_home_icon.png'
          },{
            title: 'Add me on',
            subtitle: 'LinkedIn',
            icon: 'contact_me_linkedin_icon.png',
            link: 'https://www.linkedin.com/in/nikoletatasic'
          },
        ]
      }
    },


  }
</script>

<style lang="scss">
  @import "../../css/main.scss";
  @import "../../css/contact.scss";
  @import "../../css/shapes.scss";
</style>


// WEBPACK FOOTER //
// contact.vue?5bb2d4ef